import { NotificationRepository, FcmToken } from '../NotificationRepository';

export class SaveFcmTokenUseCase {
  constructor(private repository: NotificationRepository) {}

  async execute(userId: string, tokenData: FcmToken): Promise<void> {
    if (!userId || !tokenData.token) {
      throw new Error('UserId and token are required');
    }
    await this.repository.saveToken(userId, tokenData);
  }
}
